import React, { useState } from 'react'
import { Dialog, Tooltip, IconButton } from '@material-ui/core'
import DialogView from '../../Dialogos/DialogView'
import AssignmentIcon from '@material-ui/icons/Assignment'

function DetalleCarga (props) {
  const { detalle } = props
  const [open, setOpen] = useState(false)

  const handleOpen = () => { setOpen(true) }
  const handleClose = () => { setOpen(false) }

  const renderDetalle = () => {
    const detalleDeCarga = detalle.map((p, i) => {
      return (
        <div key={p.titulo}>
          <h5>{p.titulo}: <b>{p.value}</b></h5>
        </div>
      )
    })
    return detalleDeCarga
  }

  return (
    <>
      <Dialog
        open={open}
        onClose={handleClose}
        maxWidth='md'
        fullWidth
      >
        <DialogView
          title={'Detalle de CTG'}
          cancelCallback={handleClose}
          showPrint
          content={<div
            style={{
              padding: '8px 22px',
              width: '92%',
              margin: 'auto'
            }}
          >
            { renderDetalle() }
          </div>
          }
        />
      </Dialog>

      <Tooltip title={'Ver detalle'}>
        <IconButton onClick={handleOpen}>
          <AssignmentIcon fontSize='default' color='primary' />
        </IconButton>
      </Tooltip></>
  )
}

export default DetalleCarga
